import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getPaymentType,
  getParticularPage,
  getNext,
  getPrevious,
  createPaymentType,
  updatePaymentType,
  handleSearch,
} from "./thunk";

const initialState = {
  paymentTypes: [],
  edit: false,
  paymentType: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingPaymentType: false,
  loadingNext: false,
  showCreateModal: false,
  // Form persistence state
  formData: {
    name: "",
    isActive: true,
  },
  activePaymentTypeId: null,
};

export const paymentTypeSlice = createSlice({
  name: "paymentType",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    paymentTypeEditSuccess: (state, action) => {
      state.edit = true;
      state.paymentType = state.paymentTypes.find((paymentType) => paymentType.id === action.payload);
      state.formData = state.paymentTypes.find((paymentType) => paymentType.id === action.payload);
      state.activePaymentTypeId = action.payload;
    },
    resetPaymentTypeForm: (state, action) => {
      if (action.payload) {
        state.formData = state.paymentType;
      } else {
        state.formData = initialState.formData;
        state.activePaymentTypeId = null;
      }
    },
    savePaymentTypeForm: (state, action) => {
      state.formData = action.payload;
    },
    clearAllPaymentType: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingPaymentType = false;
      state.paymentType = null;
      state.formData = initialState.formData;
      state.activePaymentTypeId = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createPaymentType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createPaymentType.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createPaymentType.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updatePaymentType.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updatePaymentType.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updatePaymentType.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addMatcher(
      isAnyOf(
        getPaymentType.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingPaymentType = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getPaymentType.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingPaymentType = false;
        state.paymentTypes = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getPaymentType.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingPaymentType = false;
      }
    );
  },
});

export const {
  setShowCreateModal,
  goToPage,
  paymentTypeEditSuccess,
  savePaymentTypeForm,
  resetPaymentTypeForm,
  clearAllPaymentType,
} = paymentTypeSlice.actions;

export default paymentTypeSlice.reducer;
